/* src/app/front-layout/webinar/webinar.component.css */
.header3 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
tp-hd {
  display: flex;
  flex-direction: column;
}
.top {
  margin-top: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.top p {
  text-align: left;
  margin: 20px;
  font-size: 16px;
}
.trust-pilot {
  display: flex;
  align-items: center;
}
.trust-pilot img {
  width: 189px;
  height: 83;
}
.nw-strp {
  background-color: #f6f6f7;
  display: flex;
  padding: 20px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.nw-strp-lft {
  display: flex;
  align-items: center;
  gap: 10px;
}
.nw-strp-rgt {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.bk-dm {
  background-color: #2489C6;
  padding: 10px;
  color: #fff;
}
.to-nmt {
  background-color: #f38d19;
  padding: 10px;
  color: #fff;
}
.lg-h {
  width: 250px;
  height: 80px;
  margin: 20px;
}
.tp-h {
  width: 150px;
  height: 65px;
  margin: 20px;
}
.container {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.hero-sec {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.hero-sec h1 {
  font-size: 48px;
  font-weight: 700;
  color: rgb(255, 255, 255);
  margin-bottom: 25px;
}
.hero-sec h2 {
  font-size: 64px;
  color: rgb(255, 255, 255);
  font-weight: 700;
  margin-bottom: 25px;
}
.hero-sec h3 {
  font-size: 24px;
  color: rgb(255, 255, 255);
  font-weight: 600;
}
.bg-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 123, 167, 0.4);
  z-index: 1;
}
.overlay-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 50px;
  justify-content: center;
}
.hero-sec > *:not(video):not(.overlay) {
  z-index: 2;
  position: relative;
}
.spacer {
  height: 50px;
}
.hero-btn {
  width: 250px;
  padding: 15px 30px;
  border: none;
  border-radius: 30px;
  background-color: #ffbf00;
  color: rgb(6, 6, 6);
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 25px;
}
.cta-1 {
  width: 250px;
  background-color: #007ba7;
  padding: 15px;
  border-radius: 15px;
  color: white;
  text-align: center;
  margin-top: 50px;
  font-size: 18px;
  font-weight: bold;
}
.hero-sub-sec img {
  width: 450px;
  height: 450px;
}
.main-img {
  width: 70%;
  position: relative;
  z-index: 1;
}
.cs-img {
  width: 650px;
  height: 450px;
  margin-left: 100px;
}
.cs-sec1 {
  display: flex;
  flex-direction: column;
  align-items: left;
}
.cs-sec1 h1 {
  font-size: 46px;
  margin: 0;
  font-weight: bold;
}
.cs-sec1 h2 {
  font-size: 30px;
  margin: 0;
  color: #ED6823;
}
.cs-sec1 h3 {
  font-size: 30px;
  margin: 0px;
  font-weight: 400;
}
.cs-sec1 h4 {
  margin: 0px;
  font-size: 20px;
  font-weight: 400;
  margin-top: 10px;
}
.cta-1 {
  width: 200px;
  background-color: #0066FF;
  color: #fff;
  padding: 12px;
  border-radius: 15px;
  text-align: center;
  text-decoration: none;
  margin-top: 50px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
}
.ft-d {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 50px;
  align-items: center;
}
.ft-d-crd {
  margin: 20px;
  width: 150px;
  height: 150px;
  display: flex;
  flex-direction: column;
  background-color: #ffbf00;
  color: #fff;
  padding: 20px;
  border-radius: 20px;
  align-items: center;
  justify-content: center;
}
.ft-d-crd img {
  width: 75px;
  margin: 5px;
}
.ft-d-crd p {
  font-weight: bold;
}
.strp-1 {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #007ba7;
  padding: 25px;
  gap: 400px;
  margin-top: 20px;
}
.strp-1 h2 {
  color: #ffbf00;
  margin: 5px;
  margin: 0px;
}
.strp-1 h3 {
  margin: 0px;
  font-weight: 300;
  font-style: italic;
  color: white;
}
.cta-2 {
  width: 250px;
  background-color: #ffbf00;
  color: #121212;
  padding: 15px;
  border-radius: 30px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
}
.upcoming-events {
  width: 100%;
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.uw-cards {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.uw-card {
  display: flex;
  align-items: center;
  background-color: #F3F3F3;
  width: 80%;
  border-radius: 20px;
  padding: 20px;
  margin-bottom: 25px;
}
.uw-card img {
  width: 300px;
  height: 300px;
  object-fit: cover;
}
.uw-card-content {
  width: 60%;
  padding: 15px;
  display: flex;
  flex-direction: column;
}
.uwc-line {
  height: 200px;
  width: 5px;
  background-color: #000000;
}
.uwc-content {
  width: 40%;
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.uwc-content h4 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}
.register-btn {
  width: 250px;
  background-color: #007ba7;
  color: white;
  border: none;
  border-radius: 50px;
  padding: 10px 20px;
  cursor: pointer;
}
.calendar {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.container2 {
  display: flex;
  flex-direction: column;
  max-width: 900px;
  max-height: 550px;
  margin: auto;
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  flex: 1;
  overflow-y: auto;
}
.toggle-buttons {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.toggle-buttons button {
  padding: 10px 20px;
  margin: 0 5px;
  border: none;
  border-radius: 20px;
  background: #d9d9d9;
  cursor: pointer;
  font-size: 16px;
}
.toggle-buttons button.active {
  background: #f38d19;
  color: white;
}
.cards {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.card-cal {
  width: 30%;
  background: #f9f9f9;
  margin: 10px;
  border-radius: 10px;
  text-align: center;
  overflow: hidden;
}
.card-header {
  background: #CBCAC8;
  color: black;
  padding: 10px;
  font-weight: bold;
}
.card-body {
  display: flex;
  flex-direction: column;
  padding: 10px;
}
.event-title {
  font-size: 18px;
  font-weight: 600;
  line-height: 22px;
}
.book-btn {
  background: #0066ff;
  color: white;
  border: none;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 10px;
  cursor: pointer;
}
.ft-wrsp {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.ch-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.sec-head {
  font-size: 40px;
  font-weight: 700;
  margin-bottom: 20px;
}
.ch-cards-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  flex-wrap: wrap;
}
.ch-card {
  width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 20px;
  padding: 10px;
  margin: 20px;
  background-color: #F7F7F7;
}
.ch-card img {
  width: 100%;
  height: 200px;
  border-radius: 20px;
}
.ch-card h4 {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
  color: black;
}
.ch-card p {
  text-align: center;
  font-weight: 600;
}
.cta-3 {
  width: 250px;
  background-color: #007ba7;
  color: #fff;
  padding: 12px;
  border-radius: 15px;
  text-align: center;
  text-decoration: none;
  margin-top: 25px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
}
.sec-3 {
  margin-top: 50px;
  background-color: #F7F7F9;
  padding: 20px;
  display: flex;
  gap: 100px;
  align-items: center;
  justify-content: center;
}
.s3-left {
  width: 50%;
  display: flex;
  flex-direction: column;
}
.sec-3 h1 {
  font-size: 36px;
  color: #007ba7;
  margin: 0px;
}
.sec-4 {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 50px;
}
.sec-4 h2 {
  font-size: 36px;
  font-weight: 500;
  margin: 0px;
}
.sec-4 h1 {
  color: #007ba7;
  font-size: 42px;
  margin: 10px 0 0 0;
}
.cs-sec {
  display: flex;
  gap: 150px;
  margin-top: 50px;
}
.cs-crd {
  display: flex;
  padding: 20px;
  width: 420px;
  gap: 5px;
  border-radius: 15px;
  background-color: #F7F7F7;
}
.cs-sec iframe {
  width: 460px;
  height: 275px;
}
.crd-cir {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  background-color: #D9D9D9;
  border-radius: 50%;
  padding: 10px;
}
.info {
  display: flex;
  flex-direction: column;
}
.strp-2 {
  margin-top: 5%;
  padding: 50px;
  background-color: #ffbf00;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.strp-2 h1 {
  color: #151414;
  text-align: center;
  font-weight: 400;
}
.cta-4 {
  padding: 20px;
  background-color: #007ba7;
  width: 300px;
  text-decoration: none;
  text-align: center;
  border-radius: 50px;
  color: #ffffff;
  font-weight: bold;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  margin-top: 25px;
}
.card-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;
}
.card-section {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-content: center;
  gap: 40px;
  margin-top: 20px;
  margin-bottom: 40px;
  max-width: 1000px;
}
.card {
  background: white;
  border: none;
  border-bottom: 5px solid #f28948;
  overflow: hidden;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease;
}
.card:hover {
  transform: translateY(-10px);
}
.card img {
  width: 100%;
  height: auto;
}
.card-content {
  padding: 15px;
}
.card h3 {
  margin: 10px 0;
  font-size: 1.2em;
}
.card p {
  font-size: 0.9em;
  color: #555;
}
.cta-three {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 250px;
  text-align: center;
  justify-content: center;
  background-color: #f7f8fa;
  cursor: pointer;
  font-size: 18px;
  font-weight: bold;
}
.cta-three h1 {
  font-weight: 300;
  color: rgb(6, 6, 6);
}
.line {
  width: 70%;
  height: 1px;
  margin: 10px;
  align-self: center;
}
.strp-3 {
  margin-top: 5%;
  padding: 30px;
  background-color: #f7f8fa;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.strp-3 h1 {
  text-align: center;
  font-weight: 400;
}
.cta-5 {
  padding: 20px;
  background-color: #007ba7;
  width: 500px;
  text-decoration: none;
  text-align: center;
  border-radius: 15px;
  color: white;
  font-weight: bold;
  cursor: pointer;
  font-size: 18px;
  font-weight: bold;
}
.cta-6 {
  padding: 15px;
  background-color: #007ba7;
  text-decoration: none;
  text-align: center;
  border-radius: 15px;
  color: white;
  font-weight: bold;
  width: 60%;
  margin-top: 50px;
  cursor: pointer;
  font-size: 18px;
  font-weight: bold;
}
.faq-sc {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.faq-sc h1 {
  margin-top: 50px;
  font-weight: bold;
  font-size: 42px;
}
.drop-d {
  width: 50%;
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border: 1px solid #000000;
}
details {
  border: 0.5px solid #000000;
  overflow: hidden;
  width: 100%;
}
summary {
  padding: 10px 15px;
  cursor: pointer;
  font-weight: bold;
  width: 100%;
  border-radius: 0;
  border: 0.5px solid #000000;
  list-style: none;
  font-size: 16px;
}
details[open] summary {
  background: #e0e0e0;
}
details div {
  padding: 15px;
  background: #fff;
}
summary::before {
  content: "\25bc    ";
  font-size: 14px;
  transition: transform 0.3s ease;
  margin-left: 10px;
}
details[open] summary::after {
  transform: rotate(180deg);
}
details div {
  padding: 0 15px;
  background: #fff;
  opacity: 0;
  height: 0;
  overflow: hidden;
  transform: scaleY(0);
  transform-origin: top;
  transition:
    transform 0.4s ease-in-out,
    opacity 0.3s ease-in-out,
    height 0.4s ease-in-out;
}
details[open] div {
  opacity: 1;
  height: auto;
  transform: scaleY(1);
  padding: 15px;
}
a {
  color: red;
  text-decoration: none;
}
.so-sc {
  display: flex;
  align-items: center;
  gap: 20px;
  margin: 25px;
}
.so-sc img {
  width: 30px;
  height: 30px;
}
.faq-sc h3 {
  text-align: center;
  margin-top: 50px;
}
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.modal-content {
  background: white;
  padding: 20px;
  width: 60%;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  position: relative;
}
.close-btn {
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 24px;
  cursor: pointer;
}
@media (max-width: 768px) {
  .top p {
    font-size: 12px;
  }
  .nw-strp {
    gap: 10px;
    padding: 5px;
  }
  .nw-strp h5 {
    font-size: 11px;
  }
  .nw-strp-lft {
    gap: 5px;
  }
  .nw-strp-rgt {
    gap: 5px;
  }
  .bk-dm {
    padding: 5px;
    font-size: 10px;
  }
  .to-nmt {
    font-size: 10px;
    padding: 5px;
  }
  .trust-pilot img {
    width: 100px;
    height: 50px;
  }
  .wave-path {
    stroke-width: 6;
  }
  .wave1 {
    top: 55%;
  }
  .wave2 {
    top: calc(55% - 60px);
  }
  .main-img {
    width: 100%;
    height: auto;
  }
  .cs-img {
    display: none;
  }
  .cs-sec1 {
    align-items: center;
    text-align: center;
  }
  .cs-sec1 h1 {
    font-size: 32px;
  }
  .cs-sec1 h2 {
    font-size: 24px;
  }
  .cs-sec1 h3 {
    font-size: 18px;
  }
  .cs-sec1 h4 {
    font-size: 16px;
  }
  .ft-d {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-content: center;
  }
  .ft-d-crd {
    width: 100px;
    height: 100px;
    margin-left: 35px;
  }
  .ft-d-crd img {
    width: 25px;
    height: 25px;
  }
  .ft-d-crd p {
    font-size: 14px;
    text-align: center;
  }
  .strp-1 {
    flex-direction: column;
    gap: 20px;
  }
  .calendar h1 {
    font-size: 24px;
  }
  .calendar h2 {
    font-size: 18px;
    margin: 20px;
    text-align: center;
  }
  .container2 {
    max-width: 95%;
    max-height: none;
    padding: 15px;
  }
  .toggle-buttons {
    flex-wrap: wrap;
    gap: 10px;
  }
  .toggle-buttons button {
    width: 100%;
    padding: 12px;
    font-size: 14px;
  }
  .cards {
    flex-direction: column;
    align-items: center;
  }
  .card-cal {
    width: 90%;
  }
  .card-header {
    font-size: 16px;
  }
  .card-body {
    padding: 15px;
  }
  .book-btn {
    width: 100%;
    padding: 12px;
    font-size: 14px;
  }
  .modal-content {
    width: 90%;
    max-height: 70vh;
    padding: 15px;
    overflow-y: auto;
  }
  .modal h1 {
    font-size: 18px;
  }
  .modal h2 {
    font-size: 16px;
  }
  .close-btn {
    top: 5px;
    right: 10px;
    font-size: 20px;
  }
  .ft-wrsp h1 {
    font-size: 24px;
    text-align: center;
    font-weight: bold;
  }
  .ft-wrsp-sc {
    flex-direction: column;
    align-items: center;
  }
  .cir {
    width: 100px;
    height: 100px;
  }
  .cir h1 {
    font-weight: 400;
    font-size: 31px;
  }
  .ft-wrsp-sc-crd {
    width: 80%;
    height: auto;
    padding: 10px;
  }
  .sec-3 {
    display: none;
  }
  .sec-4 h2 {
    font-size: 32px;
    text-align: center;
  }
  .sec-4 h1 {
    font-size: 20px;
    text-align: center;
    margin: 20px;
  }
  .cs-sec {
    width: 90%;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
  .cs-sec iframe {
    width: 90%;
  }
  .cs-crd {
    width: 100%;
  }
  .strp-2 h1 {
    font-size: 24px;
  }
  .card-section {
    display: flex;
    flex-direction: column;
  }
  .card-main h1 {
    font-size: 30px;
    text-align: center;
    font-weight: bold;
  }
  .strp-3 h1 {
    font-size: 24px;
  }
  .cta-5 {
    width: 80%;
  }
  .uw-card {
    flex-direction: column;
    width: 90%;
    padding: 15px;
  }
  .uw-card img {
    width: 100%;
    height: 200px;
    margin-bottom: 15px;
  }
  .uw-card-content {
    width: 100%;
    padding: 10px 0;
  }
  .uwc-line {
    height: 2px;
    width: 100%;
    margin: 15px 0;
  }
  .uwc-content {
    width: 100%;
    padding: 10px 0;
    align-items: flex-start;
  }
  .uwc-content h4 {
    font-size: 16px;
  }
  .register-btn {
    width: 100%;
    margin-top: 10px;
  }
  .hero-sec {
  }
  .hero-sec h1 {
    font-size: 36px;
    margin-bottom: 15px;
  }
  .hero-sec h2 {
    font-size: 48px;
    margin-bottom: 15px;
  }
  .hero-sec h3 {
    font-size: 18px;
  }
  .overlay-content {
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .spacer {
    height: 30px;
  }
  .hero-btn {
    width: 200px;
    padding: 12px 25px;
    font-size: 16px;
    margin-top: 20px;
  }
}
/*# sourceMappingURL=webinar.component.css.map */
